import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@nexus/ui";

interface FilterSelectChipProps {
  icon: ReactNode;
  label: string;
  active: boolean;
  /** A native `<select>` absolutely positioned + made invisible over the chip. */
  children: ReactNode;
}

/**
 * Pill-shaped filter control that overlays an invisible native `<select>`
 * on top of a styled label — clicking anywhere on the chip opens the native
 * dropdown. Single source for the `FilterChip` copy previously duplicated
 * across the Org, People, and Roles toolbars.
 */
export function FilterSelectChip({ icon, label, active, children }: FilterSelectChipProps) {
  return (
    <label
      className={cn(
        "relative flex cursor-pointer select-none items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors",
        active
          ? "border-primary/40 bg-primary/10 text-primary"
          : "border-border bg-transparent text-muted-foreground hover:border-foreground/30 hover:text-foreground",
      )}
    >
      {icon}
      <span className="max-w-[120px] truncate">{label}</span>
      <ChevronDown className="h-2.5 w-2.5 shrink-0 opacity-60" />
      {children}
    </label>
  );
}
